import React from 'react';
import {Container, Card} from 'react-bootstrap';
import QuickStart from '../components/quick-start';
import {useAuth} from '../auth/auth-context';
import {ImportFromPlatformsModal} from './import-pdf';

export default function QuickStartPage(): React.JSX.Element {
  const {isAuthenticated} = useAuth();
  const [showImportFromPlatformsModal, setShowImportFromPlatformsModal] =
    React.useState(false);

  return (
    <Container className='my-5'>
      <h1>Quick start</h1>
      <Card>
        <Card.Body>
          <QuickStart
            isAuthenticated={isAuthenticated}
            onOpenImportPlatformsModal={() => {
              setShowImportFromPlatformsModal(true);
            }}
          />
        </Card.Body>
      </Card>

      <ImportFromPlatformsModal
        show={showImportFromPlatformsModal}
        onHide={() => {
          setShowImportFromPlatformsModal(false);
        }}
      />
    </Container>
  );
}
